const validateArticle = async(payload) => {
  const {
          article,
          ...data
        } = payload
  
  try {
    return await axios.post(`curriculum/article/${article}/validate`, data)
  } catch (e) {
    throw e
  }
}

const validateArticleByResearchCommittee = async(payload) => {
  const {
          article,
          ...data
        } = payload
  
  try {
    return await axios.post(`curriculum/article/research-committee/${article}/validate`, data)
  } catch (e) {
    throw e
  }
}

const deleteArticle = async(payload) => {
  const {
          article,
          ...data
        } = payload
  
  try {
    return await axios.delete(`curriculum/article/${article}/delete`, {
      data: data,
    })
  } catch (e) {
    throw e
  }
}

const deletePublication = async(payload) => {
  const {
          publication,
          ...data
        } = payload
  
  try {
    return await axios.delete(`curriculum/publication/${publication}/delete`, {
      data: data,
    })
  } catch (e) {
    throw e
  }
}

export {
  validateArticle,
  validateArticleByResearchCommittee,
  deleteArticle,
  deletePublication,
}
